export const photos = [
    {
        src: "images/gallery/800x599/1.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/800x799/2.jpg",
        width: 1,
        height: 1
    },
    {
        src: "images/gallery/600x799/3.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/600x799/4.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/600x799/5.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/8.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/600x799/11.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/12.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/800x599/13.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/600x799/15.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/19.jpg",
        width: 1,
        height: 1
    },
    {
        src: "images/gallery/600x799/16.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/600x799/18.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/20.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/800x599/22.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/800x799/6.jpg",
        width: 1,
        height: 1
    },
    {
        src: "images/gallery/600x799/23.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/600x799/34.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/600x799/35.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/24.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/600x799/36.jpg",
        width: 3,
        height: 4
    },
    {
        src: "images/gallery/800x599/28.jpg",
        width: 4,
        height: 3
    },
    {
        src: "images/gallery/800x599/31.jpg",
        width: 4,
        height: 3
    }
];
  